import { Box, LinkBox, Text } from "@chakra-ui/react";
import { FC, Fragment } from "react";
import { Link } from "react-router-dom";

interface BreadCrumbProps {
  paths: { text: string; url: string }[];
}

export const BreadCrumb: FC<BreadCrumbProps> = (props) => {
  return (
    <Box
      display={{ base: "none", md: "flex" }}
      gap="1"
      fontSize="19px"
      letterSpacing="0.47px"
      mb="3px"
    >
      {props.paths.map((path, index) => {
        return (
          <Fragment key={index}>
            <Box>
              {path.url ? (
                <LinkBox
                  as={Link}
                  to={path.url}
                  color="#000"
                  _hover={{ textDecoration: "none", color: "#000" }}
                >
                  {path.text}
                </LinkBox>
              ) : (
                <Box color="#000">{path.text}</Box>
              )}
            </Box>

            {index !== props.paths.length - 1 ? (
              <Text color="#000">/</Text>
            ) : null}
          </Fragment>
        );
      })}
    </Box>
  );
};
